
import {
  defineComponent, ref, reactive, Fragment,
} from 'vue';
import {
  TreeSelect, DatePicker, Select, message,
} from 'ant-design-vue';
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment, { Moment, } from 'moment';
import { post, postDownload, } from '@/request/request';

const { Option, } = Select;
const { RangePicker, } = DatePicker;

export default defineComponent({
  components: {
    TreeSelect,
    DatePicker,
    RangePicker,
    Select,
    Option,
  },
  props: {
    activeTab: {
      type: String,
      default: () => '1',
      require: true,
    },
  },
  setup (props: { activeTab: string; }, { emit, }: any) {
    const switchBtnText = ref<string>('切换单站点');
    const treeCheckable = ref<boolean>(true);
    const timeList = [
      {
        value: 'year',
        name: '年',
      },
      {
        value: 'month',
        name: '月',
      },
      {
        value: 'day',
        name: '日',
      },
      {
        value: 'hour',
        name: '时',
      },

      /*
       * {
       *   value: 'minute',
       *   name: '分',
       * },
       */
    ];

    const resetTime = () => ({
      time: moment().subtract(1,'day'),
      rangeTime: [],
    });

    const Form = reactive<any>({
      // 站点类型 国省市微：4123
      stationType: '4',
      // 选中的站点集合
      stations: [],
      // 污染物类型
      param: 'pm25',
      // 时间粒度
      timeSize: 'hour',
    });

    const Time = reactive<any>({
      // 时间
      time: moment().subtract(1,'day'),
      // 时间范围
      rangeTime: [],
    });

    // 所有站点集合
    const stationList = ref<any>([]);
    // 请求得到的站点数据
    const stationsData = ref<any>([]);
    // 日期格式
    const timeFormat = ref<string>('YYYY-MM-DD');
    // 范围日期格式
    const rangeFormat = ref<string>('YYYY-MM-DD HH:[00]');
    // 日期格式参数格式
    const paramFormat = ref<string>('YYYYMMDDHH');
    // 时间选择器
    const timeDisable = ref<boolean>(false);
    const rangeDisable = ref<boolean>(false);
    // 是否展开
    const isOpen = ref<boolean>(false);
    // 时间选择器模式
    const dateMode = ref<any>('date');
    // 范围选择器模式
    const rangeMode = ref<any>(['date','date',]);
    // 是否可选时间
    const isShowTime = ref<boolean>(true);
    // 限制时间 时:7天 天: 30天 月: 12月
    const limitNum = ref<number>(7);
    // 范围限制单位 天:days 月:months
    const limitUnit = ref<any>('days');
    // 时间限制单位 时:day 天:month 月:year
    const timeLimitUnit = ref<string>('day');
    // 限制格式
    const limitFormat = ref<string>('YYYY-MM-DD');
    // 是否正在查询中
    const isQuery = ref<boolean>(false);
    const isDownload = ref<boolean>(false);

    /**
     * 获取数据
     * @return {void}
     */
    const loadData = (): void => {
      let params;

      const { stationType, param, } = Form;

      const airIndex = param;
      const type = Form.timeSize;

      const startTime = timeDisable.value ?
        Time.rangeTime[0].format(paramFormat.value) :
        Time.time.startOf(timeLimitUnit.value).format(paramFormat.value);

      const endTime = timeDisable.value ?
        Time.rangeTime[1].format(paramFormat.value) :
        Time.time.endOf(timeLimitUnit.value).format(paramFormat.value);

      const nameList = Form.stations.length > 0 ?
        Form.stations :
        [];

      let url = '/analyze/statisticsStandardStation';

      if (switchBtnText.value === '切换单站点') {
        params = {
          airIndex, startTime, endTime, type, nameList,
        };

        url = '/analyze/statisticsStandardStation';
      } else {
        params = {
          stationType, airIndex, startTime, endTime, type, nameList,
        };

        url = '/analyze/statisticsOneStation';
      }

      post(url, params).then((data: any,code:any) => {
        isQuery.value = false;
        // emit
        emit('getListData', { listData: data.reverse(), paramFormat: paramFormat.value, });
      }).catch((msg: string) => {
        emit('getListData', { listData: [], paramFormat: null, });
        message.error(msg);
        isQuery.value = false;
      });
    };

    /**
     * 日期改变 时、日生效；月、年不生效
     * @param {any} value 日期值
     * @return {void}
     */
    const handleCalendarChange = (value:any):void => {
      Time.rangeTime = value;
    };

    /**
     * 日期面板打开关闭
     * @param {*} status 状态
     * @param {*} type 状态
     * @return {void}
     */
    const handleOpenChange = (status: any, type: string):void => {
      if (type === 'time') {
        isOpen.value = status;
      }
    };

    /**
     * 日期面板改变 （时、日）（月、年）生效方式不一样
     * @param {*} value 值
     * @param {*} type 类型
     * @return {void}
     */
    const handlePanelChange = (value:any, type:string): void => {
      if (type === 'time') {
        Time.time = value;
        isOpen.value = false;
        if (value) {
          rangeDisable.value = true;
        } else {
          rangeDisable.value = false;
        }
      } else {
        Time.rangeTime = value;
        if (value.length > 0) {
          timeDisable.value = true;
          Time.time = null;
        } else {
          timeDisable.value = false;
          Time.time = moment().subtract(1,'day');
        }
      }
    };

    /**
     * 日期范围
     * @param {*} current 当前选择时间
     * @param {*} type 类型
     * @return {void}
     */
    const disabledDate = (current:any, type: string):any => {
      if (type === 'range') {
        if (!Time.rangeTime || Time.rangeTime.length === 0) {
          return moment(current).format(limitFormat.value).valueOf() > moment().format(limitFormat.value).valueOf();
        }
        const diffDate1 = moment(current).diff(Time.rangeTime[0], limitUnit.value);
        const diffDate2 = moment().diff(Time.rangeTime[0], limitUnit.value);

        if (diffDate2 < limitNum.value) {
          return diffDate1 < 0 || diffDate1 > diffDate2;
        }

        return diffDate1 < 0 || diffDate1 >= limitNum.value;
      }

      return moment(moment().format(timeFormat.value)).valueOf() < moment(current.format(timeFormat.value)).valueOf();
    };

    const range = (start:any, end:any) => {
      const temp = [];

      for (let i = start; i < end; i++) {
        temp.push(i);
      }

      return temp;
    };

    /**
     * 时间范围
     * @param {*} _ 当前选择时间
     * @param {*} type 前后
     * @return {any} 时间
     */
    const disabledTime = (current: any, type: string) => {
      if (!Time.rangeTime || Time.rangeTime.length === 0) {
        return {
          disabledHours: () => [],
        };
      }

      if (type === 'start') {
        return {
          disabledHours: () => range(0, Time.rangeTime[0].hour()),
        };
      }

      return {
        disabledHours: () => {
          if (Time.rangeTime[0].format('YYYY-MM-DD').valueOf() === moment().format('YYYY-MM-DD').valueOf()) {
            return range(moment().hour(), 24);
          }

          return range(Time.rangeTime[0].hour() + 1, 24);
        },
      };
    };

    /**
     * 处理数据
     * @method dealStation
     * @param {any} value 数据对象
     * @param {any} type 类型
     * @returns {any[]}数组
     */
    const dealStation = (value: any, type: any): any[] => {
      let temp: any = {};

      temp = [{
        value: '国控站',
        label: '国控站',
        children: [],
        selectable: false,
        type: 4,
      },
      {
        value: '省控站',
        label: '省控站',
        children: [],
        selectable: false,
        type: 1,
      },
      {
        value: '市控站',
        label: '市控站',
        children: [],
        selectable: false,
        type: 2,
      },
      {
        value: '小微站',
        label: '小微站',
        children: [],
        selectable: false,
        type: 3,
      },];

      const tempType = temp.map((i: any) => i.type);

      value.forEach((item: any) => {
        const index = tempType.indexOf(Number(item.type));

        temp[index].children.push(
          {
            value: item.name,
            label: item.name,
          }
        );
      });

      return temp;
    };

    /**
     * @method loadAllStation
     * @param {any} value 类型
     * @return {void} 切换
     */
    const loadAllStation = (value:any): void => {
      post(`/analyze/selectAllStation`, { type: value, }).then((data: any) => {
        stationList.value = dealStation(data, value);
        stationsData.value = data;
        // 默认不打开微站
        Form.stations = data.filter((cur: any) => cur.type !== '3').map((cur:any) => cur.name);
        // 站点数据获取到之后，请求列表数据
        loadData();
        emit('changeStationType', {
          stationList: stationList.value,
          stations: Form.stations,
        });
      }).catch((msg: string) => {
        message.error(msg);
      });
    };

    loadAllStation('all');

    /**
     * @method handleSelect
     * @param {any} value 类型
     * @param {string} type 类型
     * @return {void} 切换
     */
    const handleSelect = (value: any, type: string): void => {
      // Form.param = value;
      if (switchBtnText.value === '切换单站点' || type !== 'stations') {
        Form[type] = value;
      } else {
        Form[type] = [value,];
      }

      if (type === 'stations') {
        const curSelect = stationList.value.filter((item: any) => item.children.find((i: any) => i.value === value));

        Form.stationType = curSelect[0].type;
      }

      if (type === 'timeSize') {
        Object.assign(Time, resetTime());
        timeDisable.value = false;
        rangeDisable.value = false;
        switch (value) {
        case 'year':
          Time.rangeTime = [moment().subtract(1,'year'), moment(),];
          timeDisable.value = true;
          timeFormat.value = 'YYYY';
          rangeFormat.value = 'YYYY';
          paramFormat.value = 'YYYY';
          rangeMode.value = ['year','year',];
          isShowTime.value = false;
          break;
        case 'month':
          Time.time = moment();
          timeFormat.value = 'YYYY';
          rangeFormat.value = 'YYYY-MM';
          paramFormat.value = 'YYYYMM';
          dateMode.value = 'year';
          rangeMode.value = ['month','month',];
          isShowTime.value = false;
          limitNum.value = 12;
          limitUnit.value = 'months';
          timeLimitUnit.value = 'year';
          limitFormat.value = 'YYYY-MM';
          break;
        case 'day':
          Time.time = moment();
          timeFormat.value = 'YYYY-MM';
          rangeFormat.value = 'YYYY-MM-DD';
          paramFormat.value = 'YYYYMMDD';
          dateMode.value = 'month';
          rangeMode.value = ['date','date',];
          isShowTime.value = false;
          limitNum.value = 30;
          limitUnit.value = 'days';
          timeLimitUnit.value = 'month';
          limitFormat.value = 'YYYY-MM-DD';
          break;
        case 'hour':
          Time.time = moment();
          timeFormat.value = 'YYYY-MM-DD';
          rangeFormat.value = 'YYYY-MM-DD HH:[00]';
          paramFormat.value = 'YYYYMMDDHH';
          dateMode.value = 'date';
          rangeMode.value = ['date','date',];
          isShowTime.value = true;
          limitNum.value = 7;
          limitUnit.value = 'days';
          timeLimitUnit.value = 'day';
          limitFormat.value = 'YYYY-MM-DD';
          break;
        default:
          break;
        }
      }
    };

    /**
     * @method handleSearch
     * @return {void} 查询
     */
    const handleSearch = ():void => {
      if (isQuery.value) {
        return;
      }

      isQuery.value = true;
      loadData();
      emit('setParams', Form.param);
    };

    /**
     * @method handleDownload
     * @return {void} 下载弹窗
     */
    const handleDownload = ():void => {
      emit('handleDownload');
    };

    /**
     * @method handleClick
     * @return {void} 下载
     */
    const handleClick = ():void => {
      if (isDownload.value) {
        return;
      }

      if (props.activeTab === '1') {
        isDownload.value = true;
        // 文件名
        const name = `${timeDisable.value ?
          Time.rangeTime[0].format(paramFormat.value) :
          Time.time.startOf(timeLimitUnit.value).format(paramFormat.value)}-${timeDisable.value ?
          Time.rangeTime[1].format(paramFormat.value) :
          Time.time.endOf(timeLimitUnit.value).format(paramFormat.value)}所选站点${Form.param}历史数据`;

        const params = {
          stationType: Form.stationType,
          airIndex: Form.param,
          startTime: timeDisable.value ?
            Time.rangeTime[0].format(paramFormat.value) :
            Time.time.startOf(timeLimitUnit.value).format(paramFormat.value),
          endTime: timeDisable.value ?
            Time.rangeTime[1].format(paramFormat.value) :
            Time.time.endOf(timeLimitUnit.value).format(paramFormat.value),
          type: Form.timeSize,
          nameList: Form.stations.length > 0 ?
            Form.stations :
            [],
        };

        postDownload(`/analyze/downStationByAirIndex`, params, name).then(() => {
          isDownload.value = false;
        }).catch(() => {
          isDownload.value = false;
          message.error('下载失败');
        });
      } else {
        emit('downloadChart');
      }
    };

    const handleSwitch = ():void => {
      if (switchBtnText.value === '切换单站点') {
        switchBtnText.value = '切换单指标';
        treeCheckable.value = false;
        Form.stations = [stationList.value[0].children[0]?.value || '',];
        Form.stationType = '4';
        emit('setTableType', 2);
      } else {
        switchBtnText.value = '切换单站点';
        treeCheckable.value = true;
        Form.stations = stationsData.value.filter((cur: any) => cur.type !== '3').map((cur:any) => cur.name);
        emit('setTableType', 1);
      }
      loadData();
    };

    return {
      locale,
      Form,
      Time,
      timeList,
      stationList,
      timeFormat,
      rangeFormat,
      paramFormat,
      timeDisable,
      rangeDisable,
      isOpen,
      dateMode,
      rangeMode,
      isShowTime,
      isQuery,
      switchBtnText,
      treeCheckable,
      stationsData,
      handleCalendarChange,
      handleOpenChange,
      handlePanelChange,
      disabledDate,
      disabledTime,
      handleSelect,
      handleSearch,
      handleDownload,
      handleClick,
      handleSwitch,
    };
  },
});
